import ImageSlider from "./Slider";
export default ImageSlider;